import React, { useState, useEffect } from "react";
import axios from "axios";

const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

const ReportBussiness = () => {
    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_REPORT = "api/erpppsu/report/RingkasanBisnis";

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [filterPeriod, setFilterPeriod] = useState("weekly");
    const [filterFirstDate, setFilterFirstDate] = useState(getTodayDate());
    const [filterLastDate, setFilterLastDate] = useState(getTodayDate());

    const fetchData = async (URL) => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get(URL);
            setData(response.data || []);
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (filterPeriod && filterFirstDate && filterLastDate) {
            const URL = `${BASE_URL}${PATH_REPORT}?period=${filterPeriod}&first_date=${filterFirstDate}&last_date=${filterLastDate}`;
            fetchData(URL);
        }
    }, []);

    const handleFilter = () => {
        if (filterPeriod && filterFirstDate && filterLastDate) {
            const URL = `${BASE_URL}${PATH_REPORT}?period=${filterPeriod}&first_date=${filterFirstDate}&last_date=${filterLastDate}`;
            fetchData(URL);
        }
    };

    if (error) return <div className="text-red-500">{error}</div>;

    return (
        <div className="p-4">
            <h1 className="text-lg font-bold mb-4">Laporan Arus Kas</h1>

            <div className="container m-auto grid grid-cols-5 sm:grid-cols-2 xs:grid-cols-1 md:grid-cols-3 lg:grid-cols-5 my-3 gap-4">
                {/* First Date Input */}
                <div className="mx-1">
                    <label htmlFor="first_date" className="block mb-1 text-sm font-semibold">
                        Tanggal Awal
                    </label>
                    <input
                        id="first_date"
                        name="first_date"
                        type="date"
                        className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                        value={filterFirstDate}
                        onChange={(e) => setFilterFirstDate(e.target.value)}
                    />
                </div>

                {/* Last Date Input */}
                <div className="mx-1">
                    <label htmlFor="last_date" className="block mb-1 text-sm font-semibold">
                        Tanggal Akhir
                    </label>
                    <input
                        id="last_date"
                        name="last_date"
                        type="date"
                        className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                        value={filterLastDate}
                        onChange={(e) => setFilterLastDate(e.target.value)}
                    />
                </div>

                {/* Period Selection */}
                {/* <div className="mx-1">
                    <label htmlFor="period" className="block mb-1 text-sm font-semibold">
                        Periode
                    </label>
                    <select
                        id="period"
                        name="period"
                        className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                        value={filterPeriod}
                        onChange={(e) => setFilterPeriod(e.target.value)}
                    >
                        <option value="monthly">1 Bulan</option>
                        <option value="weekly">1 Minggu</option>
                    </select>
                </div> */}

                {/* Filter Button */}
                <div className="p-3 flex items-end">
                    <button
                        onClick={handleFilter}
                        type="button"
                        className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200"
                    >
                        Filter
                    </button>
                </div>
            </div>

            {loading ? (
                <center><h1>Loading...</h1></center>
            ) : (
                data.map((section, index) => (
                    <div key={index} className="mb-6">
                        <h2 className="text-md font-semibold mb-2">{section.label}</h2>
                        <table className="min-w-full border-collapse border border-gray-300">
                            <thead>
                                <tr>
                                    <th className="border border-gray-300 px-2 py-1 text-left">Deskripsi</th>
                                    <th className="border border-gray-300 px-2 py-1 text-right">Jumlah</th>
                                </tr>
                            </thead>
                            <tbody>
                                {section.data.map((item, idx) => (
                                    <tr key={idx}>
                                        <td className="border border-gray-300 px-2 py-1">{item.label}</td>
                                        <td className="border border-gray-300 px-2 py-1 text-right">
                                            {item.amount.toLocaleString("id-ID", { style: "currency", currency: "IDR" })}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ))
            )}
        </div>
    );
};

export default ReportBussiness;
